
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"33.117","height":"34.24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":".919","y1":".403","x2":".283","y2":".817","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":".18","stop-color":"#0052cc"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#2684ff"}})]),_c('linearGradient',{attrs:{"id":"b","x1":".087","y1":".592","x2":".722","y2":".18","xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M32.72 16.162L17.986 1.428 16.558 0 5.467 11.091l-5.07 5.071a1.356 1.356 0 000 1.916l10.132 10.133 6.029 6.029 11.091-11.091.172-.172 4.9-4.9a1.356 1.356 0 000-1.916zm-16.162 6.02l-5.061-5.062 5.062-5.062 5.062 5.062z","fill":"#2684ff"}}),_c('path',{attrs:{"d":"M23.164 12.107A8.524 8.524 0 0123.127.09L12.05 11.163l6.029 6.029z","transform":"translate(-6.605 -.049)","fill":"url(#a)"}}),_c('path',{attrs:{"d":"M41.715 37.85l-5.075 5.075a8.524 8.524 0 010 12.058l11.1-11.1z","transform":"translate(-20.082 -20.744)","fill":"url(#b)"}})])
          )
        }
      }
    